import { TypedUseSelectorHook, useSelector } from 'react-redux';

const useAppSelector: TypedUseSelectorHook<IAppState> = useSelector;

export default useAppSelector;
